/* eslint-disable no-useless-constructor */
import React, { useState } from 'react' 
import * as THREE from "three";
import { saveAs } from 'file-saver' ;
import {Table} from "antd";
import {message} from "antd" ;
import {DatePicker, TimePicker } from "antd";
import {Space} from "antd" ;
import {Button} from "antd" ;
import {Drawer} from 'antd';
import {Radio} from "antd" ;
import { Menu, Dropdown } from 'antd';
import { Modal } from 'antd';
import { Typography } from 'antd';
import { Divider } from 'antd';
import { CloseSquareFilled } from '@ant-design/icons'
import { DownOutlined} from '@ant-design/icons';
import { DownSquareOutlined, UpSquareOutlined } from '@ant-design/icons'
import { QuestionCircleOutlined } from '@ant-design/icons';
import moment from 'moment'
import Display_Manager from './Orbit_Display.js';
import { epoch_to_date_time } from './Orbit_Display.js'
import { SketchPicker } from 'react-color';
import { CirclePicker } from 'react-color';
import { Tooltip } from 'antd' ;
import { Checkbox } from 'antd' ;
import { Input } from 'antd';
import { Slider } from 'antd';
import { InputNumber } from 'antd';
import { Switch } from 'antd';
import Draggable from 'react-draggable';
import help_icon from './images/help_icon.png' ;
import { chooser_help, transport_help, main_help,orbit_data_header, orbit_data_footer } from './help_text.js';
import { sprintf } from 'sprintf-js' ;
import ReactMarkdown from 'react-markdown' ;
import remarkGfm from 'remark-gfm' ;
import properties from './properties.txt' ;
import Message_Queue from './message_box.js';
import { EARTH_RADIUS, REF_FRAME } from './Orbit.js';
import { ENT_type } from './entity_manager.js'
import { COORD_System } from './Orbit.js'
import { key_to_coord_system } from './Orbit.js'
import { coord_system_to_key } from './Orbit.js'

import { DEF_SC_COLOR, DEF_SC_SHAPE } from './constants.js'
import { DEF_ORB_STYLE } from './constants.js'
import { UNASSIGNED_SC_COLOR } from './constants.js'
import { UNASSIGNED_SC_SHAPE } from './constants.js'
import { UNASSIGNED_ORBIT_STYLE } from './constants.js'
import { SSC_WS_ACCESS } from './constants.js'
import { TT_BGCOLOR } from './constants.js'
import { PLANETS } from './planet_data.js'
import { MIN_DIALOG_HEIGHT, MIN_DIALOG_WIDTH } from './constants.js'
import { EXPORT_DIALOG_WIDTH } from './constants.js'
import { SCREENSHOT_DIALOG_WIDTH } from './constants.js'
import { OPTIONS_DIALOG_WIDTH } from './constants.js'
import { HELP_DIALOG_HEIGHT, HELP_DIALOG_WIDTH } from './constants.js'
import { DIALOG_SPACE_FACTOR } from './constants.js'
import { DIALOG_HEIGHT } from './constants.js'
import { DEF_BACKGROUND_COLOR } from './constants.js'
import { DEF_GRID_SIZE, DEF_GRID_SCALE, DEF_GRID_OFFSET } from './constants'

import { V3DSpace } from './App.js'
import display_space from './3DSpace.js';

//import { display } from 'html2canvas/dist/types/css/property-descriptors/display.js';


function use_min_width (disp_width)
    {
    return (disp_width < MIN_DIALOG_WIDTH * DIALOG_SPACE_FACTOR)? true : false
    }

const xp_dlg_width = (disp_width) =>
    {
    return (use_min_width (disp_width))? MIN_DIALOG_WIDTH : EXPORT_DIALOG_WIDTH
    }

const opt_dlg_width = (disp_width) =>
    {
    return (use_min_width (disp_width))? MIN_DIALOG_WIDTH : OPTIONS_DIALOG_WIDTH
    }

const scr_dlg_width = (disp_width) =>
    {
    return (use_min_width (disp_width))? MIN_DIALOG_WIDTH : SCREENSHOT_DIALOG_WIDTH
    }

const hlp_dlg_width = (disp_width) =>
    {
    return (use_min_width (disp_width))? MIN_DIALOG_WIDTH : SCREENSHOT_DIALOG_WIDTH
    }

function get_dlg_style (disp_width, calc)
    {
    const modal_style = {
        width: calc (disp_width) + "px", 
        height: DIALOG_HEIGHT + "px", 
        overflowY: 'auto',
        }

    return modal_style
    }

function get_help_dialog_style (disp_width, disp_height)
    {
    const use_min_height = disp_height < HELP_DIALOG_HEIGHT * DIALOG_SPACE_FACTOR
    const use_min_width = disp_width < HELP_DIALOG_WIDTH * DIALOG_SPACE_FACTOR

    const mh = (use_min_height)? MIN_DIALOG_HEIGHT : HELP_DIALOG_HEIGHT
    const mw = (use_min_width)?  MIN_DIALOG_WIDTH : HELP_DIALOG_WIDTH

    const modal_style = {
        width: mw.toFixed()+"px", 
        height: mh.toFixed()+"px", 
        overflowY: 'auto',
        }

    console.log (JSON.stringify (modal_style))

    return modal_style
    }

function get_bounds_box (disp_width, disp_height, calc)
    {
    const dw = calc (disp_width)
    const dh = DIALOG_HEIGHT

    const vd = Math.floor ((disp_height - dh) / 2) 
    const hd = Math.floor ((disp_width - dw) / 2) 

    const b = {
        top: -vd, 
        bottom: vd,
        left: -hd,
        right: hd,
        }

    return b
    }

function date_param_to_epoch (date) 
    {
    if  (! date)
        {
        return null 
        }

    const year = parseInt (date.substring (0, 4), 10)
    const month = parseInt (date.substring (4, 6), 10) - 1 // JavaScript months are 0-based
    const day = parseInt (date.substring (6, 8), 10)

    let hour = 0
    let min = 0
    let sec = 0
  
    if  (date.length >= 15 && date.substring (8,9) === 'T')
        {
        hour =  parseInt (date.substring (9, 11), 10)
        min =  parseInt (date.substring (11, 13), 10)
        sec =  parseInt (date.substring (13, 15), 10)
        }

    // Return the epoch time in milliseconds
    const r = new Date (Date.UTC (year, month, day, hour, min, sec, 0))

    return r.getTime ()
    }

function get_user_string (suggest) 
    {     
    const { confirm } = Modal ;

    // const modal_width = 400 

    let result = false ;

    confirm (
        {
        title: 'Select Orbit Color',
        content: <Input default={suggest} id={"get_user_string"}/>,
        icon: null,
        onOk () {},
        onCancel () {},
        }) ;

    return (result) ;
    }

function start_of_current_day ()
    {
    // Return a Date object representing the start of the current day in UTC
    const now = new Date ()

    const year = now.getUTCFullYear ()
    const month = now.getUTCMonth ()
    const day = now.getUTCDate ()


    return new Date (Date.UTC (year, month, day, 0, 0, 0, 0))
    }

function default_end_time ()
    {
    // The default end time is defined as the start of the current day
    // Time is returned in ms
    return start_of_current_day ().getTime ()
    }

function default_start_time (interval)
    {
    // The default start time is defined as the start of the current day
    // minus interval days.
    const date = start_of_current_day () 

    // Subtract days
    date.setUTCDate (date.getUTCDate() - interval)

    // Convert to epoch time in milliseconds
    return date.getTime ()
    }

    function File_Name (props)
    {
    const {save_file_name, update_save_file_name} = props 

    return (
        <>
            <tr className="grid-row">
                <td colSpan={2}>
                    <div className='op-text grid-col-span'>
                        File Name:
                    </div>
                </td>
            </tr>
            
            <tr className="grid-row">
                <td colSpan={2}>
                    <div className='op-text grid-col-span'>
                        <Input 
                            style={{width: "50%"}}
                            bordered={true}
                            id={"get_user_string"}
                            value={save_file_name}
                            onChange={update_save_file_name}
                            />
                    </div>
                </td>
            </tr>
        </>
        ) ;
    }

function Save_Method_Select (props)
    {
    const {update_save_target, save_file_name, save, update_save_file_name} = props

    const request_file_name = 
        <File_Name 
            save_file_name={save_file_name} 
            update_save_file_name = {update_save_file_name}
            /> ;

    const select_method =
        <tr className="grid-row">
            <td className="grid-col-1">
                <div className='op_section_title'>
                    <Tooltip    
                        placement="right" 
                        color={TT_BGCOLOR}                            
                        title={'Save to a file or open content in new window'}
                        >
                        Target for Save
                    </Tooltip>
                </div>
            </td>
            <td className="grid-col-2">
                <div className="op_action">
                    <Radio.Group onChange={update_save_target} value={save}>
                        <Radio value={true}>Save as file</Radio>
                        <Radio value={false}>Open in New Window</Radio>
                    </Radio.Group>
                </div>
            </td>
        </tr>;

    return (
        <>
        {select_method}
        {save && request_file_name}
        </>
        ) ;

    }

function Save_Log_Menu (props)
    {
    const {text, helptext, action, save, update_save_target, save_file_name, update_save_file_name} = props

    const [show_menu, set_show_menu] = useState (false)


    if  (show_menu)
        {
        return (
            <> 
                <Show_Hide_Button 
                    enable = {true}
                    text={text}
                    helptext={helptext}
                    action={() => set_show_menu (false)}
                    />
                <Save_Method_Select 
                    save={save}
                    update_save_target={update_save_target}
                    save_file_name={save_file_name}
                    update_save_file_name={update_save_file_name}
                    />
                <Cancel_or_OK text="OK" action={action} />
            </>
            ) ;
         
        }

    else 
        {
        return (
            <Show_Hide_Button 
                enable = {false}
                text={text}
                helptext={helptext}
                action={() => set_show_menu (true)}
                />
            ) ; 
        }
    }

function Show_Button (props)
    {
    return (
        <Button
            size="large"
            type="ghost"
            onClick={props.action} 
            style={{border: "none"}}
            >
            <DownSquareOutlined style={{ fontSize: '32px'}}/>
        </Button>
        ) ;
    }

function Hide_Button (props)
    {
    return (
        <Button
            size="large"
            type="ghost"
            onClick={props.action} 
            style={{border: "none"}}
            >
            <UpSquareOutlined style={{ fontSize: '32px'}}/>
        </Button>
        ) ;
    }

function Cancel_or_OK (props)
    {
    const {text, helptext, action, cancel, cancel_action} = props

    const OK_button = 
        <Button
            size="large"
            type="primary"
            shape="round"
            onClick={action} 
            style={{border: "none"}}
            >
            {text}
        </Button> ;

    const OK = (helptext)?
        <Tooltip    
            placement="right" 
            color={TT_BGCOLOR}                            
            title={helptext}
            >
            {OK_button}
        </Tooltip>
        : OK_button ;

    const cancel_button = (cancel)? 
        <Button
            size="large"
            type="primary"
            shape="round"
            onClick={cancel_action} 
            style={{border: "none"}}
            >
            Cancel
        </Button> 
        : null ;

    const CNCL = (cancel && helptext)?
        <Tooltip    
            placement="right" 
            color={TT_BGCOLOR}                            
            title={"Cancel action."}
            >
            {cancel_button}
        </Tooltip>
        : cancel_button ;

        const buttons = (cancel)? <> {CNCL} {OK} </> :  <> {OK} </> ;

    return (
        <tr className="grid-row">
            <td colSpan="2">
                <div className='op-text grid-col-span'>
                    {buttons}
                </div>
            </td>
        </tr>
        ) ;
    }

function Show_Hide_Button (props)
    {
    const {text, helptext, enable, action} = props

    const button = (enable) ? 
        <Show_Button action={action}/> :
        <Hide_Button action={action}/>

    return (
        <tr className="grid-row">
            <td className="grid-col-1">
                <div className="op_section_title" >
                    <Tooltip    
                        placement="right" 
                        color={TT_BGCOLOR}                            
                        title={helptext}
                        >
                        {text}
                    </Tooltip>
                </div>
            </td>
            <td className="grid-col-2">
                <div className='op_action'>
                    {button}
                </div>
            </td>
        </tr>
        ) ;    
    }

class Calendar extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        this.handle_change = this.handle_change.bind (this) ;
        }

    handle_change (t) 
        {
        t.utc (true)
        console.log ("new time ", t)
        this.props.update_time (t) ;
        }

    render () 
        {
        // should there really be valueOf() in the default case?
        const set_time = this.props.time ? moment.utc(this.props.time) : moment.utc().valueOf()
        
        const time_string = set_time.format('MMM DD YYYY HH:mm:ss') ;

        return (
            <div className="calendar_display">
                <div className="time_select_display">
                    <DatePicker value={set_time} onChange={this.handle_change} />
                    <TimePicker value={set_time} onChange={this.handle_change} />
                </div>
                <div>
                    {this.props.lbl} : {time_string}
                </div>
            </div>
            );
        }
    }

class Display_Table extends React.Component
    {
    constructor (props)
        {
        super (props)

        this.state =  {
            filter: ["available"],
            }

        this.check_for_color_change = this.check_for_color_change.bind (this) 
        this.filter_row = this.filter_row.bind (this) ;
        this.control_filter = this.control_filter.bind (this) 
        //this.start   = this.start.bind (this) ;
        this.render = this.render.bind (this)
        }

    check_for_color_change (record, prev_record)
        {
        return  (record.color !== prev_record.color) ? true : false ;
        }

    filter_row (value, record)
        {
        // Returns true (display row) or false (hide row) based on the desired filter (value).
        // record is the record for the row being filtered.

        if  (value === "selected")
            {
            return record.display ;
            }

        if  (value === "available")
            {
            return record.available ;
            }

        return 1;
        }

    control_filter (e) 
        {
        this.setState ({filter: [e.target.value],}) ;
        }
        
    render() 
        {
        //let obs = this.state.obs ;
        const select_parameters = 
            {
            selectedRowKeys: this.props.selected,
            hideSelectAll: true,
            onSelect: this.props.handle_select_change,
            };
            
        const columns = 
        [
            {
            title: 'Name',
            dataIndex: 'name',
            filters: [
                {
                    text: 'selected',
                    value: 'selected',
                },
                {
                    text: 'available',
                    value: 'available',
                },

            ],
            filteredValue: this.state.filter,
            onFilter: this.filter_row,
            filterMultiple: false,
            filterDropdownVisible: false,
            render: (obs_name, record, index) => {
                const s = {} 
                s.padding = "2px"
                s.width = "90px"
                s.minHeight = "25px" 
                const button_style = {}
                button_style.color = "black"
                button_style.backgroundColor = "transparent"
                button_style.border = "none"
                button_style.cursor = "pointer"
                button_style.padding = "0" 
                button_style.outline = "none"
                button_style.textAlign = "left"     
                let render ;
                if  (record.display)
                    {
                    render =                     
                        <button style={button_style}
                            onClick={() => this.props.set_focus(record.id)}>
                            <div style={s}>{obs_name}</div>
                        </button>;                    }
                else
                    {
                    render = <div style={s}>{obs_name}</div> ;
                    }
                return (
                        {
                        props: null,
                        children:                    
                            <Space  size="middle">
                                {render}
                            </Space>
                        } 
                    ) ;
                },
            },

            {
            title: 'Color',
            dataIndex: 'color',
            editable: true,
            render: (color, record, index) => {
                const s = {} ;
                s.padding = 2 ;
                s.width = 40 ;
                s.height = 15 ;
                s.backgroundColor = color ;
                return (
                <Space size="middle">
                    <a href="javascript:;" onClick={() => this.props.get_new_color (color, record)}>
                    <div style={s}  >
                    </div>
                    </a>
                </Space>
                )
                },
            },
        
            {
            title: 'Shape',
            dataIndex: 'shape',
            editable: true,
            render: (shape, record, index) => {
                const menu_selection = (
                    <Menu onClick= {(item) => this.props.get_new_shape (item.key, record)}>  
                        <Menu.Item key="sphere">
                        sphere
                        </Menu.Item>
                        <Menu.Item key="cylinder">
                        cylinder
                        </Menu.Item>
                        <Menu.Item key="cone">
                        cone
                        </Menu.Item>
                        <Menu.Item key="diamond" disabled="true">
                        diamond
                        </Menu.Item>
                        <Menu.Item key="cube">
                        cube
                        </Menu.Item>
                    </Menu>
                    ) ;      

                const button_style = {}
                button_style.backgroundColor = "transparent" ;
                button_style.border = "1px solid black";
                button_style.cursor = "pointer";
                button_style.borderRadius = "4px" ;
                button_style.overflow = "hidden";
                button_style.outline = "none";
                button_style.color = "black";
        
                return (
                    <Dropdown overlay={menu_selection}>
                        <button 
                            type="button"
                            style={button_style}
                            onClick={e => e.preventDefault()}
                            >
                            {shape}<DownOutlined />
                        </button>
                    </Dropdown>
                    ) ;
               }
            },
        ] ;  

        const selection_options = 
            [
                { label: 'All', value: 'all', },
                { label: 'Available', value: 'available' },
                { label: 'Selected', value: 'selected' },
            ] ;

       return (<div className="list_display">
                <div className="list_display_inner_space">
                <Radio.Group
                    options={selection_options}
                    onChange={this.control_filter}
                    value={this.state.filter [0]}    
                    optionType="button"
                    buttonStyle="solid"
                    defaultValue="available"
                    />
                </div>
                <div className="list_display_inner_space">
                <Table  rowSelection= {select_parameters} 
                        columns= {columns} 
                        pagination={false} 
                        scroll={{ y: 240 }} 
                        className="mission_list"
                        dataSource={this.props.obs} 
                        />
                </div>
            </div>
        );
        }
    }

class Get_Ground_Stations extends React.PureComponent
    {
    constructor (props)
        {
        super (props)
        }

    componentDidMount() 
        {
        const req_headers = new Headers
                (
                    {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Content-Length': 0,
                    }
                );

        const gs_request = new Request
                (SSC_WS_ACCESS + 'WS/sscr/2/groundStations',
                {
                method: 'GET',
                headers: req_headers,
                mode: 'cors',
                cache: 'default',
              });
              

        fetch (gs_request)
            
        .then (res => res.json())
        .then ( (data) => {
                const stations = data[1].GroundStation[1] ; 
                const GS = [] ;

                for (let i = 0; i < stations.length; i++) 
                    {
                    const loc = stations[i][1].Location [1]

                    //console.log (stations[i][1].Id )

                    const s = { 
                        key: i,
                        id: stations[i][1].Id,
                        name: stations[i][1].Name,
                        latt: loc.Latitude,
                        long: loc.Longitude,
                        } 

                    GS.push (s)
                    
                    } 
                                
                this.props.ground_stations (GS) ;
                }
              )

        .catch (console.log)
        }

    render ()
        {
        return (null) ;
        }
    }

class Get_Observatories extends React.PureComponent
    {
    constructor (props)
        {
        super (props)

        this.find_default_properties = this.find_default_properties.bind (this) ;
        }

    find_default_properties (name)
        {
        let i = 0 ;
        let found = false ;

        const r = {color: DEF_SC_COLOR, shape: DEF_SC_SHAPE, style: DEF_ORB_STYLE}

        while (i < this.props.display_properties.length)
            {
            if  (name === this.props.display_properties [i].name)
                {
                found = true ;
                break ;
                }

            i++ ;
            }

        // if  (name === "yohkoh") alert ("done search " + i + " " + found) ;
        if  (found)
            {
            const triple = this.props.display_properties [i].color ;

            const red   = ('0' + triple[0].toString(16).toUpperCase()).slice (-2) ;
            const green = ('0' + triple[1].toString(16).toUpperCase()).slice (-2) ;
            const blue  = ('0' + triple[2].toString(16).toUpperCase()).slice (-2) ;

            r.color = "#" + red + green + blue ;

            switch (this.props.display_properties [i].shape)
                {
                case "sphere" :

                    r.shape = "sphere" ;
                    break ;

                case "cube" :

                    r.shape = "cube" ;
                    break ;

                case "cylinder" :

                    r.shape = "cylinder" ;
                    break ;

                case "cone" :

                    r.shape = "cone" ;
                    break ;
            
                default:

                    break ;
                }
            }

            // console.log (JSON.stringify (this.props.display_properties [i]))

            if  (this.props.display_properties [i]?.style)
                {
                r.style = this.props.display_properties [i]?.style
                }

            if  (this.props.display_properties [i]?.orbit)
                {
                r.orbit = this.props.display_properties [i]?.orbit
                }

            if  (this.props.display_properties [i]?.cadence)
                {
                r.cadence = this.props.display_properties [i]?.cadence
                }

            // console.log (JSON.stringify (r))

            return r ;
        }

    componentDidMount() 
        {
        const req_headers = new Headers
                (
                    {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Content-Length': 0,
                    }
                );

        const obs_request = new Request
                (SSC_WS_ACCESS + 'WS/sscr/2/observatories', //https://sscweb-dev.sci.gsfc.nasa.gov
                {
                method: 'GET',
                headers: req_headers,
                mode: 'cors',
                cache: 'default',
              });
              

        fetch (obs_request)
            
        .then (res => res.json())
        .then ( (data) => {
                          const obs = data [1].Observatory[1] 
                          const sats = [] ;
                          const start_time = this.props.start_time ;
                          const end_time = this.props.end_time ;

                          for (let i = 0; i < obs.length; i++) 
                              {
                              // Exclude all BARREL missions
                              if  ((obs[i][1].Id).startsWith ('barrel'))
                                  {
                                  continue
                                  }

                              const obs_start_time = moment.utc(obs[i][1].StartTime[1]).valueOf() ;
                              const obs_end_time   = moment.utc(obs[i][1].EndTime[1]).valueOf() ;
                              const available = (end_time < obs_start_time || start_time > obs_end_time )? false : true ;

                              const d = this.find_default_properties (obs[i][1].Id) ;

                              const o = {
                                    key: i,
                                    id: obs[i][1].Id,
                                    name: obs[i][1].Name,
                                    color: d.color,
                                    shape: d.shape,
                                    start_time: obs_start_time,
                                    end_time: obs_end_time,
                                    display: false,
                                    available: available,
                                    orbit: d.orbit,
                                    cadence: d.cadence             
                                    } 
                              //console.log (o.id)
                              sats.push (o)
                              } 
                                
                          this.props.obs (sats) ;
                          }
              )

        .catch (console.log)
        }

    render ()
        {
        return (null) ;
        }
    }
class  Grid_Options extends React.Component
    {
    render ()
        {
        return (
            <>
                <div className="op_action">
                    <span style={{width: "10em"}}> Grid Size </span>
                    <InputNumber 
                        name={'size'}
                        controls={true}
                        defaultValue={DEF_GRID_SIZE}
                        min={1}
                        onBlur={this.props.update}
                        />
                    </div>
                <div className="op_action">
                    <span style={{width: "10em"}}> Grid Cell Size </span>
                    <InputNumber
                        name={'scale'}
                        controls={true}
                        defaultValue={DEF_GRID_SCALE}
                        min={1}
                        onBlur={this.props.update}
                        />
                </div>
                <div className="op_action">
                    <span style={{width: "10em"}}> Offset From Center </span>
                    <InputNumber
                        name={'offset'}
                        controls={true}
                        defaultValue={DEF_GRID_OFFSET}
                        onBlur={this.props.update}
                        />
                </div>
            </>
            ) ;
        }
    }

// This probably needs to go somewhere else.
class Control_Layout extends React.Component 
    {
    constructor (props)
        {
        super (props)    

        this.state =  {
            selected: []
            }

        this.handle_select_change  = this.handle_select_change.bind (this) 
        this.componentDidMount = this.componentDidMount.bind (this)
        this.add_spacecraft = this.add_spacecraft.bind (this)
        this.close_action = this.close_action.bind (this)
        }
        
    add_spacecraft (record)
        {
        if  (V3DSpace.end_time < record.start_time || V3DSpace.start_time > record.end_time )
            {
            const status_msg = {
                content: 'Orbit data not available for selected time range.',
                className: 'time_set_error',
                style: {marginTop: '15vh',},
                }

            message.error (status_msg) 

            return false
            }

        V3DSpace.add_spacecraft ({
            id: record.id, 
            color: record.color, 
            shape: record.shape, 
            focus: null,
            name: record.name, 
            type: ENT_type.SPACECRAFT, 
            start_time: record.start_time, 
            end_time: record.end_time,
            orbit_class: record.orbit, 
            cadence: record.cadence
            })

        record.display = true 

        return true 
        }

    handle_select_change (record, add_flag) 
        {
        if  (add_flag)
            {

            if  (! this.add_spacecraft(record))
                {
                return false
                }

            const current_selection = this.state.selected 
            const new_selection = [...current_selection, record.key] 
 
            this.setState ({selected: new_selection,})

            return true
            }

        else
            {
            const current_selection = this.state.selected 
            const i = current_selection.indexOf (record.key) 
                
            const new_selection = 
                (current_selection.length > 0) ?
                    [...current_selection.slice(0,i),...current_selection.slice(i+1)] :
                    [] ;
         
            record.display = false 

            V3DSpace.remove (record.id) 

            this.setState ({selected: new_selection,})

            return true
            }
        }

    componentDidMount ()
        {
        const sc_id = this.props.sats.map (s => s.id)
        const select = []

        this.props.request.forEach (e =>
            {
            const id = sc_id.indexOf (e)

            if  (id !== -1)
                {
                if  (this.add_spacecraft (this.props.sats [id]))
                    {
                    select.push (this.props.sats [id].key)
                    }
                }            
            }) ;

        this.setState ({selected: select,})        
        }

    close_action ()
        {
        V3DSpace.update_orbit_data ().then (failed => {
            if  (failed.length > 0)
                {
                let select = [...this.state.selected]

                failed.forEach (id => {
                     
                    const rec = this.props.sats.findIndex (sat => sat.id === id) 
                    const i = select.indexOf (rec)

                    select = (select.length > 0) ? [...select.slice(0,i),...select.slice(i+1)] : []
                     
                    this.props.sats [rec].display = false
                    })

                this.setState ({selected: select,})
                }
            })

        this.props.hide_l_sidebar ()
        }


    render ()
        {
        const { Title } = Typography;

        return (
            <div className="controls">
                <div className="controls_title_bar">
                    <Title style={{color: "#EEEEDE"}} level={3}>Viewer Controls</Title>
                    <Button
                        size="large"
                        type="ghost"
                        style={{border: "none"}}
                        onClick={this.props.display_help} 
                        >
                        <img src={help_icon} className= "icon_image" alt="" />
                    </Button> 
                </div>
                <Divider style={{borderColor: "#FFFFFF"}} />
                <div className="cp_subsection_title ">
                    Select start of display interval:
                </div>
                <Calendar   
                    lbl={'Start Time'}
                    time={this.props.start_time}
                    update_time={this.props.update_view_start_time}
                    />
                <div className="cp_subsection_title cp_subsection_title_space">
                    Select end of display interval:
                </div>
                <Calendar   
                    lbl={'End Time'}
                    time={this.props.end_time}
                    update_time={this.props.update_view_end_time}
                    />
                <div className="cp_subsection_title cp_subsection_title_space">
                    Select observatories:
                </div>
                <Display_Table 
                    get_new_color={this.props.get_new_color}
                    get_new_shape={this.props.get_new_shape}
                    set_focus={this.props.set_focus}
                    obs={this.props.sats}
                    selected={this.state.selected}
                    request={this.props.request}
                    handle_select_change={this.handle_select_change}
                    />
                <Button 
                    type="primary" 
                    size='large' 
                    onClick={this.close_action}
                    style={{
                        transform:'rotate(90deg)',
                        position: 'absolute',
                        top: '15%',
                        left: '90%'
                        }}
                    >
                    Display Orbits      
                </Button>
    
            </div>
            ) ;
        }
    }

class Read_Properties_File extends React.Component
    {
    constructor (props)
        {
        super (props) ;
        }

    componentDidMount ()
        {
        fetch(properties)
            .then(r => r.text())
            .then(text => {
                const lines = text.split ("\n") ;

                const s = [] ;

                for (let i = 0 ; i < lines.length ; i++)
                    {
                    // const [mission, r, g, b, shape] = lines [i].split (/[\s,]/) ;
                    const f = lines [i].split (/[\s,]/)

                    const mission = f.shift ()

                    if  (f.length === 0 || f [0] === "*")
                        {
                        if  (f [0] === "*")
                            {
                            f.shift ()
                            }

                        f.unshift (UNASSIGNED_SC_COLOR [0], UNASSIGNED_SC_COLOR [1], UNASSIGNED_SC_COLOR [2]) 
                        }
                        
                    const r = f.shift ()
                    const g = f.shift ()
                    const b = f.shift ()

                    if  (f.length === 0 || f [0] === "*")
                        {
                        if  (f [0] === "*")
                            {
                            f.shift ()
                            }

                        f.unshift (UNASSIGNED_SC_SHAPE)
                        }

                    const shape = f.shift ()

                    if  (f.length === 0 || f [0] === "*")
                        {
                        if  (f [0] === "*")
                            {
                            f.shift ()
                            }

                        f.unshift (UNASSIGNED_ORBIT_STYLE)
                        }

                    const style = f.shift ()
        
                    const orbit = (f.length === 0)? "L" : f.shift ()
                    const cadence = (f.length === 0)? 60 : f.shift ()

                    //console.log ("mission %s shape %s style %s orbit %s ", mission, shape, style, orbit)
                    s.push ({
                        name: mission, 
                        color: [+r,+g,+b], 
                        shape: shape,
                        style: style,
                        orbit: orbit,
                        cadence: cadence
                        }) ;
                    }
                

                // update the whatever.
                this.props.set_properties (s) ;
                });
        }

    render ()
        {
        return (null) ;
        }
    }

class Options extends React.Component
    {
    constructor (props)
        {
        super (props) ;
        
        this.state = {
            axes_length_slider_disable: this.props.axes_length === 0,
            axes_length: this.props.axes_length === 0 ? 1 : this.props.axes_length,
            display_bg_palette: false, 
            }

        this.marks = {
            1:  '1',
            2:  '2',
            3:  '3',
            4:  '4',
            5:  '5',
            6:  '6',
            7:  '7',
            8:  '8',
            }

        this.toggle_axes = this.toggle_axes.bind (this) ;
        this.update_axes_length = this.update_axes_length.bind (this) ;
        this.toggle_bg_color_palette = this.toggle_bg_color_palette.bind (this) ;
        this.create_bg_color_palette = this.create_bg_color_palette.bind (this) ;
        }

    toggle_axes (event)
        {
        const new_state = this.state.axes_length_slider_disable? false: true ;

        this.props.toggle_axes_display (event) ;

        this.setState ({
            axes_length_slider_disable: new_state,
            axes_length: 1,
            }) ;
        }

    create_bg_color_palette ()
        {
        if  (! this.state.display_bg_palette)
            {
            return (
                <div className="op_action"  >
                    <Button
                        size="large"
                        type="ghost"
                        onClick={this.toggle_bg_color_palette} 
                        style={{border: "none"}}
                        >
                        <DownSquareOutlined style={{ fontSize: '32px'}}/>
                    </Button>
                </div>
                ) ;
            }

        return (
            <div className="op_action"  >
                <SketchPicker   
                    onChangeComplete={ this.props.update_bg_color } 
                    color={this.props.bgcolor}
                    disableAlpha={ true }
                    width={'60%'}
                    />
                <Button
                    size="large"
                    type="ghost"
                    onClick={this.toggle_bg_color_palette} 
                    style={{border: "none"}}
                    >
                    <UpSquareOutlined style={{ fontSize: '32px'}}/>
                </Button>

            </div>
            ) ;
        }

    toggle_bg_color_palette ()
        {
        this.setState ({display_bg_palette: ! this.state.display_bg_palette}) ;
        }

    update_axes_length (new_axes_length)
        {
        this.props.update_axes_length (new_axes_length) ;

        this.setState({axes_length: new_axes_length}) ;
        }

    render ()
        {
        const cp = this.create_bg_color_palette () ;

        return (
            <table className="grid">
                <tbody>
                <tr className="grid-row" key={1}>
                    <td colSpan="2">
                        <div className='op-text grid-col-span'>
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Hide time selection slider except for when the mouse hovers over 
                                        the bottom of the screen.  When disabled, the time selection slider
                                        will always be visible.`}
                                >
                                Hide Time Selection Slider Except On Mouse Over
                            </Tooltip>
                            <Switch 
                                onChange={this.props.toggle_hide_time_control}
                                checked={this.props.hide_time_control}
                                />
                        </div>
                    </td>
                </tr>
                <tr className="grid-row" key={2}>
                    <td colSpan="2">
                        <div className='op-text grid-col-span'>
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Show floating labels near displayed spacecraft. When disabled,
                                        no floating labels will be visible.`}
                                >
                                Show spacecraft labels
                            </Tooltip>
                            <Switch 
                                onChange={this.props.toggle_show_decals}
                                checked={this.props.show_decals}
                                />
                        </div>
                    </td>
                </tr>
                <tr className="grid-row" key={3}>
                    <td colSpan="2">
                        <div className='op-text grid-col-span'>
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Show floating labels near planets. When disabled,
                                        no floating labels will be visible.`}
                                >
                                Show planet labels
                            </Tooltip>
                            <Switch 
                                onChange={this.props.toggle_show_planet_decals}
                                checked={this.props.show_planet_decals}
                                />
                        </div>
                    </td>
                </tr>
                <tr className="grid-row" key={4}>
                    <td className="grid-col-1">
                        <div className="op_section_title" >
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Display or hide XYZ axes markers.`}
                                >
                                Display Axes
                            </Tooltip>
                        </div>
                    </td>
                    <td className="grid-col-2">
                        <div className="op_action" >
                        <Switch 
                            onChange={this.toggle_axes }
                            checked={! this.state.axes_length_slider_disable}
                            />
                        </div>
                    </td>
                </tr>
                <tr className="grid-row" key={5}>
                    <td className="grid-col-1">
                        <div className="op_section_title" >
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Set the length of the XYZ axes markers when visible.`}
                                >
                                Set Axes Length
                            </Tooltip>
                        </div>
                    </td>
                    <td className="grid-col-2">
                        <Slider 
                            min={1}
                            max={8}
                            value={this.state.axes_length}
                            marks={this.marks}
                            dots={true}
                            disabled={this.state.axes_length_slider_disable}
                            onChange={this.update_axes_length}
                        />
                    </td>
                </tr>
                <tr className="grid-row" key={6}>
                    <td className="grid-col-1">
                        <div className="op_section_title" >
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Select a color to use for the background (sky).`}
                                >
                                Set Background Color
                            </Tooltip>
                        </div>
                    </td>
                    <td className="grid-col-2">
                        {cp}
                    </td>
                </tr>
                <tr className="grid-row" key={7}>
                    <td colSpan="2">
                        <div className='op-text grid-col-span'>
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Display an overlay that gives the position in GSE coordinates of 
                                        every currently displayed spacecraft.`}
                                >
                                Display Spacecraft Position Overlay
                            </Tooltip>
                            <Switch 
                                onChange={this.props.toggle_show_sc_position}
                                checked={this.props.show_sc_position}
                                />
                        </div>
                    </td>
                </tr>
                <tr className="grid-row" key={8}>
                    <td className="grid-col-1">
                        <div className="op_section_title" >
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Set the overall size, grid size and offset from center
                                        of the XZ axis grid plane.`}
                                >
                                XZ Grid Plane Options
                            </Tooltip>
                        </div>
                    </td>
                    <td className="grid-col-2">
                    <Grid_Options 
                            key="xz"
                            update={this.props.set_xz_grid_options}
                            />                        
                    </td>
                </tr>
                <tr className="grid-row" key={9}>
                    <td className="grid-col-1">
                        <div className="op_section_title" >
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Set the overall size, grid size and offset from center
                                        of the YZ axis grid plane.`}
                                >
                                YZ Grid Plane Options
                             </Tooltip>
                        </div>
                    </td>
                    <td className="grid-col-2-flex">
                    <Grid_Options 
                            key="yz"
                            update={this.props.set_yz_grid_options}
                            />
                    </td>
                </tr>
                <tr className="grid-row" key={10}>
                    <td className="grid-col-1">
                        <div className="op_section_title" >
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Set the overall size, grid size and offset from center
                                        of the XY axis grid plane.`}
                                >
                                XY Grid Plane Options
                            </Tooltip>
                        </div>
                    </td>
                    <td className="grid-col-2">
                    <Grid_Options 
                            key="xy"
                            update={this.props.set_xy_grid_options}
                            />
                    </td>
                </tr>
                <Save_Log_Menu 
                    save={this.props.save}
                    update_save_target={this.props.update_save_target}
                    save_file_name={this.props.save_file_name} 
                    update_save_file_name={this.props.update_save_file_name}
                    text="Show or Save Log File"
                    helptext="Show or save the content of the console log."
                    action={this.props.log_action}
                    />

                </tbody>
            </table>
            ) ;
        }
    }

class Listing_Select_Row extends React.Component
    {
    constructor (props)
        {
        super (props) ;
        }

    render ()
        {
        return (
            <tr className="grid-row" key={this.props.id}>
                <td className='grid-checkbox'>
                    <Checkbox 
                        name={this.props.spacecraft} 
                        index={this.props.index}
                        checked={this.props.checked} 
                        onChange={this.props.update}>
                    </Checkbox>
                </td>
                <td>
                    <div className="op-text" >
                        {this.props.spacecraft}
                    </div>
                </td>
            </tr>
            )
        }

    }

class Listing_Select extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        this.state = {
           } ;

        this.get_output_type = this.get_output_type.bind (this) ;
        }

    get_file_name ()
        {
        return (
            <>
                <tr className="grid-row">
                    <td colSpan={2}>
                        <div className='op-text grid-col-span'>
                            File Name:
                        </div>
                    </td>
                </tr>
                
                <tr className="grid-row">
                    <td colSpan={2}>
                        <div className='op-text grid-col-span'>
                            <Input 
                                style={{width: "50%"}}
                                bordered={true}
                                id={"get_user_string"}
                                value={this.props.save_file_name}
                                onChange={this.props.update_save_file_name}
                                />
                        </div>
                    </td>
                </tr>
            </>
            ) ;
        }
   
    get_output_type () 
        {
        const request_file_name = this.get_file_name ()

        return (
            <>
                <tr className="grid-row">
                    <td>
                        <div className='op-text grid-col-1'>
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Select the appropriate action to either save the
                                        exported orbit data to a file or to make it available for
                                        viewing/printing in new pop-up window.`}
                                >
                                Show or Save Orbit Data
                            </Tooltip>
                        </div>
                    </td>
                    <td>
                        <div className='op-text grid-col-2'>
                            <Radio.Group onChange={this.props.update_save_target} value={this.props.save}>
                                <Space direction='vertical'>
                                <Radio value={true}>Save File</Radio>
                                <Radio value={false}>Open in New Window</Radio>
                                </Space>
                            </Radio.Group>
                        </div>
                    </td>
                </tr>
                {this.props.save && request_file_name}
            </>
            )
        }

    render ()
        {
        const select_target = this.get_output_type () ;

        return (
            <div >
                <table className="grid">
                    <tbody>
                        {
                        V3DSpace.get_all_sc_id().map ((id, i) =>
                            <Listing_Select_Row  
                                update={this.props.update}
                                checked={this.props.list[i]}
                                spacecraft={id}
                                key={id}
                                id={id}
                                index={i}
                                /> 
                            )
                        }
                    </tbody>
                </table>
                <table className="grid above-modal-footer">
                    <tbody>
                        {select_target}
                    </tbody>
                </table>
            </div>                            
            ) ;
        }
    }

class Coordinate_System_Select extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        this.state = {
           req_coord_system: this.props.system,
           ref_frame: this.props.current_ref_frame 
           } ;

        this.local_update = this.local_update.bind (this)
        this.select_rotating_ref_frame = this.select_rotating_ref_frame.bind (this)
        }

    select_rotating_ref_frame (e)
        {
        this.setState ({ref_frame: e.target.checked})

        this.props.update_ref_frame (e)
        }

    local_update (e)
        {
        this.setState ({req_coord_system: key_to_coord_system (e.target.name)})

        this.props.update (e)
        }

    render ()
        {
            /* Saved in case I want to use it later...
                <div className="op-horizontal-line"></div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="ER_frame" 
                            checked={this.state.ref_frame} 
                            onChange={this.select_rotating_ref_frame}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        
                    </div>
                    <div className="op-text-light" >
                        Use Earth Centered / Earth rotating reference frame
                    </div>
                </div>
            */


        return (
            <div style={{display:'flex',flexDirection:'column'}}>
                <div className="op_row">
                    <div className="op_row_subtitle op-text-subtitle"> Geocentric Coordinate Systems </div>
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="gse" 
                            checked={this.state.req_coord_system === COORD_System.GSE} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        GSE
                    </div>
                    <div className="op-text-light" >
                        Geocentric Solar Ecliptic
                    </div>                   
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="gei" 
                            checked={this.state.req_coord_system === COORD_System.GEI} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text  op_label" >
                        GEI
                    </div>
                    <div className="op-text-light" >
                        Geocentric Equatorial Inertial
                    </div>
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="gei2000" 
                            checked={this.state.req_coord_system === COORD_System.GEI2000} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        J2000
                    </div>
                    <div className="op-text-light" >
                        Geocentric Equatorial Inertial for epoch J2000.0
                    </div>
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="gsm" 
                            checked={this.state.req_coord_system === COORD_System.GSM} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        GSM
                    </div>
                    <div className="op-text-light" >
                        Geocentric Solar Magnetospheric system
                    </div>
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="sm" 
                            checked={this.state.req_coord_system === COORD_System.SM} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        SM
                    </div>
                    <div className="op-text-light" >
                        Solar Magnetic coordinates
                    </div>
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="geo" 
                            checked={this.state.req_coord_system === COORD_System.GEO} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        GEO
                    </div>
                    <div className="op-text-light" >
                        Geographic coordinate system
                    </div>
                </div>
                <div className="op-horizontal-line"></div>
                <div className="op_row">
                    <div className="op_row_subtitle op-text-subtitle"> Heliocentric Coordinate Systems </div>
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="hae" 
                            checked={this.state.req_coord_system === COORD_System.HAE} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        HAE
                    </div>
                    <div className="op-text-light" >
                        Heliocentric Aries Ecliptic
                    </div>
                </div>
                <div className="op_row">
                    <div className="op_checkbox">
                        <Checkbox 
                            name="hee" 
                            checked={this.state.req_coord_system === COORD_System.HEE} 
                            onChange={this.local_update}>
                        </Checkbox>
                    </div>
                    <div className="op-text op_label" >
                        HEE
                    </div>
                    <div className="op-text-light" >
                        Heliocentric Earth Ecliptic
                    </div>
                </div>
           </div>
            ) ;
        }
    }

class Screen_Image extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        this.componentDidUpdate = this.componentDidUpdate.bind (this)
        this.componentDidMount = this.componentDidMount.bind (this)
        this.post_render = this.post_render.bind (this)

        this.img = React.createRef () ;
        }

    post_render ()
        {
        //const ar = this.props.disp_height / this.props.disp_width
        //const img_width = Math.floor (this.props.width * .8)
        //const img_height = Math.floor (img_width * ar) 

        //const display = this.img.current

        //display.height = img_height
        //display.width = img_width

        const ctx = this.img.current.getContext('2d')

        ctx.drawImage (this.props.compost, 0, 0, this.props.img_width, this.props.img_height)
        //ctx.fillText("Hello World", 10, 50) 
        //ctx.drawImage (this.props.compost, 0, 0)
        //this.test.current.appendChild (this.props.compost)
        }

    componentDidMount ()
        {
        this.post_render ()
        }

    componentDidUpdate ()
        {
        this.post_render ()
        }

    render ()
        {
        const img_style = {
            height: Math.floor (this.props.img_height * 1.2) + 'px',
            textAlign: "center",
            verticalAlign: "center",
            }

        return (
            <tr className="grid-row">
                <td colSpan="2" style = {img_style}>
                    <div style={{padding: "5px"}}>
                        <canvas
                            width={this.props.img_width}
                            height={this.props.img_height} 
                            className='screen_image'
                            ref={this.img}
                            >
                        </canvas>
                    </div>
                </td>
            </tr>
            ) ;
        }
    }

class Img_File_Select extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        this.state = {
           } ;

        this.get_file_name=this.get_file_name.bind (this)
        }

    get_file_name ()
        {
        return (
            <>
                <tr className="grid-row">
                    <td colSpan={2}>
                        <div className='op-text grid-col-span'>
                            File Name:
                        </div>
                    </td>
                </tr>
                
                <tr className="grid-row">
                    <td colSpan={2}>
                        <div className='op-text grid-col-span'>
                            <Input 
                                style={{width: "50%"}}
                                bordered={true}
                                id={"get_user_string"}
                                value={this.props.save_file_name}
                                onChange={this.props.update_save_file_name}
                                />
                        </div>
                    </td>
                </tr>
            </>
            ) ;
        }
   
    render ()
        {
        const request_file_name = this.get_file_name ()


        return (
            <> 
                <tr className="grid-row">
                    <td>
                        <div className='op-text grid-col-1'>
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Select the appropriate action to take a screenshot
                                        as a PNG image and either save it or display in a 
                                        new window.`}
                                >
                                Show or Save a Screenshot of the Current Screen
                            </Tooltip>
                        </div>
                    </td>
                    <td>
                        <div className='op-text grid-col-2'>
                            <Radio.Group onChange={this.props.update_save_target} value={this.props.save}>
                                <Radio value={true}>Save as file</Radio>
                                <Radio value={false}>Open in New Window</Radio>
                            </Radio.Group>
                        </div>
                    </td>
                </tr>
                {this.props.save && request_file_name}
            </>
            ) ;
        }
    }

class IMG_Save_Modal extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        this.state = {
            display_bg_palette: false, 
            }

        this.background_colors = [
            "#f44336", 
            "#e91e63", 
            "#9c27b0", 
            "#673ab7", 
            "#3f51b5", 
            "#2196f3", 
            "#03a9f4", 
            "#00bcd4", 
            "#000000", 
            "#4caf50", 
            "#8bc34a", 
            "#cddc39", 
            "#ffeb3b", 
            "#ffc107", 
            "#ff9800", 
            "#ff5722", 
            "#795548", 
            "#607d8b"
            ]

        this.create_save_bg_color_palette=this.create_save_bg_color_palette.bind (this)
        this.toggle_bg_color_palette=this.toggle_bg_color_palette.bind (this)
        this.palette_button = this.palette_button.bind (this)
        this.orphan_palette = this.orphan_palette.bind (this)
        this.palette_chooser = this.palette_chooser.bind (this)
        }

    toggle_bg_color_palette ()
        {
        this.setState ({display_bg_palette: ! this.state.display_bg_palette}) ;
        }

    button_show ()
        {
        return (
            <Button
                size="large"
                type="ghost"
                onClick={this.toggle_bg_color_palette} 
                style={{border: "none"}}
                >
                <DownSquareOutlined style={{ fontSize: '32px'}}/>
            </Button>
            ) ;
        }

    button_hide ()
        {
        return (
            <Button
                size="large"
                type="ghost"
                onClick={this.toggle_bg_color_palette} 
                style={{border: "none"}}
                >
                <UpSquareOutlined style={{ fontSize: '32px'}}/>
            </Button>
            ) ;
        }

    palette_button ()
        {
        return (this.state.display_bg_palette)? this.button_show () : this.button_hide ()
        }

    create_save_bg_color_palette ()
        {
        return (
            <div className="op_action"  >
                {this.palette_chooser ()}
                {this.palette_button ()}
            </div>
            ) ;
        }

    orphan_palette_button ()
        {
        return (
            <div className="op_action">
                {this.palette_button ()}
            </div>
            ) ;
        }

    palette_chooser ()
        {
        if  (this.state.display_bg_palette)
            {
            return (
                <CirclePicker
                    onChangeComplete={ this.props.update_bg_color } 
                    colors={this.background_colors}
                />
                ) ;
            }

        return (null)
        }

    orphan_palette ()
        {
        if  (this.state.display_bg_palette)
            {
            return (
                <tr className="grid-row">
                    <td colSpan="2">
                        <div className='grid-col-center'>
                            {this.palette_chooser ()}
                        </div>
                    </td>
                </tr>
                ) ;
            }

        return (null)
        }

    create_color_select_control ()
        {
        if  (this.props.use_narrow_format)
            {
            const r = 
                <>
                    <tr className="grid-row">
                        <td className="grid-col-1">
                            <div className="op_section_title" >
                                <Tooltip    
                                    placement="right" 
                                    color={TT_BGCOLOR}                            
                                    title={`Select a color to use for the background of 
                                            the saved image.`}
                                    >
                                    Set Background Color for Image Save
                                </Tooltip>
                            </div>
                        </td>
                        <td className="grid-col-2">
                            {this.orphan_palette_button ()}
                        </td>
                    </tr> 
                    {this.orphan_palette ()}
                </> ;

            return r
            }

        else 
            {
            const r = 
                <tr className="grid-row">
                    <td className="grid-col-1">
                        <div className="op_section_title" >
                            <Tooltip    
                                placement="right" 
                                color={TT_BGCOLOR}                            
                                title={`Select a color to use for the background of 
                                        the saved image.`}
                                >
                                Set Background Color for Image Save
                            </Tooltip>
                        </div>
                    </td>
                    <td className="grid-col-2">
                        {this.create_save_bg_color_palette () }
                    </td>
                </tr> ;

            return r
            }
        }

    render ()
        {
        const color_select = this.create_color_select_control ()

        return (
                <table className="grid">
                    <tbody>
                        <Screen_Image 
                            img_width={this.props.img_width}
                            img_height={this.props.img_height}
                            compost={this.props.compost}
                            />
                        {this.create_color_select_control ()}
                        <Img_File_Select

                            update={this.props.update}
                            update_save_target={this.props.update_save_target}
                            save={this.props.save}
                            save_file_name={this.props.save_file_name}
                            update_save_file_name={this.props.update_save_file_name}
                            />

                    </tbody>
                </table>
            )
        }
    }

class Base_Layout extends React.Component
    {
    constructor (props)
        {
        super (props) ;

        //const default_grid_setting = {
        //    size: 20, 
        //    scale: 1, 
        //    offset: 0, 
        //    color: ""
        //    }

        this.state =  {
            l_sidebar_visible: false,
            axes_length: 1,
            show_options_dialog: false,
            show_save_dialog: false,
            show_image_dialog: false,
            show_coord_dialog: false,
            compost: null,
            list: Array.from ({ length: V3DSpace.get_number_sc () }, () => false),
            bgcolor: DEF_BACKGROUND_COLOR,
            save_file_name: "orbit_data",
            img_save_file_name: "screenshot",
            log_save_file_name: "log",
            save_to_file: false,
            img_save_to_file: true,
            log_save_to_file: true,
            hide_time_control: false,
            show_decals: true,
            show_planet_decals: true,
            show_sc_position: true,
            //coord_system: V3DSpace.coord_system, 
            //xz_grid_options: {...default_grid_setting},
            //yz_grid_options: {...default_grid_setting},
            //xy_grid_options: {...default_grid_setting},
            }

        this.ui = React.createRef ()

        this.capture = new OffscreenCanvas (256, 256)

        document.getElementById('bg').style.backgroundColor = this.state.bgcolor

        this.show_l_sidebar = this.show_l_sidebar.bind (this) ;
        this.hide_l_sidebar = this.hide_l_sidebar.bind (this) ;
        this.toggle_l_sidebar = this.toggle_l_sidebar.bind (this) ;
        this.display_chooser_help_dialog = this.display_chooser_help_dialog.bind (this) ;
        this.display_main_help_dialog = this.display_main_help_dialog.bind (this) ;
        this.display_transport_bar_help_dialog = this.display_transport_bar_help_dialog.bind (this)
        this.open_option_menu = this.open_option_menu.bind (this) ;
        this.close_option_menu = this.close_option_menu.bind (this) ;
        this.open_save_menu = this.open_save_menu.bind (this) 
        this.copy_search_url = this.copy_search_url.bind (this)
        this.close_save_menu = this.close_save_menu.bind (this) ;
        this.update_compost_bg_color=this.update_compost_bg_color.bind (this)
        this.open_image_save_menu = this.open_image_save_menu.bind (this) 
        this.open_coord_dialog = this.open_coord_dialog.bind (this)
        this.close_coord_dialog = this.close_coord_dialog.bind (this)
        this.close_image_save_menu = this.close_image_save_menu.bind (this) ;
        this.update_selected_for_save = this.update_selected_for_save.bind (this) ;
        this.save_selected_orbits=this.save_selected_orbits.bind (this) ;
        this.save_image=this.save_image.bind (this) ;
        this.update_save_target=this.update_save_target.bind (this) 
        this.update_coord_system = this.update_coord_system.bind (this)
        this.update_img_save_target=this.update_img_save_target.bind (this)
        this.update_log_save_target=this.update_log_save_target.bind (this)
        this.update_axes_length =this.update_axes_length.bind (this) ;
        this.toggle_axes_display = this.toggle_axes_display.bind (this) ;
        this.update_bg_color=this.update_bg_color.bind (this) ;
        this.toggle_hide_time_control=this.toggle_hide_time_control.bind (this) ;
        this.toggle_show_decals=this.toggle_show_decals.bind (this)
        this.toggle_show_planet_decals=this.toggle_show_planet_decals.bind (this)
        this.update_save_file_name=this.update_save_file_name.bind (this)
        this.update_img_save_file_name=this.update_img_save_file_name.bind (this)
        this.update_log_save_file_name=this.update_log_save_file_name.bind (this)
        this.save_or_display_log=this.save_or_display_log.bind (this)
        this.toggle_show_sc_position=this.toggle_show_sc_position.bind (this) ;
        this.set_xz_grid_options=this.set_xz_grid_options.bind (this) ;
        this.set_yz_grid_options=this.set_yz_grid_options.bind (this) ;
        this.set_xy_grid_options=this.set_xy_grid_options.bind (this) ;
        this.set_screen_capture_background=this.set_screen_capture_background.bind (this)
        }

    //update_screen_size (width, height)
    //    {
    //    this.setState ({disp_width: width, disp_height: height})
    //    }

    update_bg_color (color)
        {
        // Calculate the new display text color.
        V3DSpace.set_bg_color (color.hex)

        document.documentElement.style.setProperty("--txt_color", V3DSpace.text_color)

        document.getElementById('bg').style.backgroundColor = color.hex
        
        this.setState ({bgcolor: color.hex}) ;
        }

    update_axes_length (new_axes_length)
        {
        V3DSpace.update_axes_length (new_axes_length)

        this.setState ({axes_length: new_axes_length}) ;
        }

    toggle_axes_display ()
        {
        const new_axes_length = (this.state.axes_length === 0)? 1 : 0

        V3DSpace.update_axes_length (new_axes_length)

        this.setState ({axes_length: new_axes_length,}) ;
        }

    toggle_hide_time_control ()
        {
        this.setState ({hide_time_control: (this.state.hide_time_control === false)? true : false,}) ;
        }

    toggle_show_decals ()
        {
        const visible = (this.state.show_decals === false)? true : false

        V3DSpace.set_sc_label_visible (visible)

        this.setState ({show_decals: visible,})
        }

    toggle_show_planet_decals ()
        {
        const visible = (this.state.show_planet_decals === false)? true : false

        V3DSpace.set_planet_label_visible (visible)

        this.setState ({show_planet_decals: visible,})
        }

    toggle_show_sc_position ()
        {
        this.setState ({show_sc_position: (this.state.show_sc_position === false)? true : false,}) ;
        }

    display_chooser_help_dialog ()
        {
        const { info } = Modal ;

        const w = parseInt (get_help_dialog_style (V3DSpace.width, V3DSpace.height).width, 10)

        info (
            {
            title: null,
            content: <ReactMarkdown 
                            className="help_text" 
                            children={chooser_help} 
                            remarkPlugins={[remarkGfm]}
                            />,
            icon: null,
            centered: true,
            width: w,
            onOk () {},
            }) ;
        }

    display_main_help_dialog ()
        {
        const { info } = Modal ;

        const w = parseInt (get_help_dialog_style (V3DSpace.width, V3DSpace.height).width, 10)

        info (
            {
            title: null,
            content: <ReactMarkdown 
                            className="help_text" 
                            children={main_help} 
                            remarkPlugins={[remarkGfm]}
                            />,
            icon: null,
            centered: true,
            width: w,
            onOk () {},
            }) ;

        }

    display_transport_bar_help_dialog ()
        {
        const { info } = Modal ;

        const w = parseInt (get_help_dialog_style (V3DSpace.width, V3DSpace.height).width, 10)

        info (
            {
            title: null,
            content: <ReactMarkdown 
                            className="help_text" 
                            children={transport_help} 
                            remarkPlugins={[remarkGfm]}
                            />,
            icon: null,
            centered: true,
            width: w,
            onOk () {},
            }) ;

        }

    open_option_menu ()
        {
        this.setState({show_options_dialog: true}) ;
        }

    close_option_menu ()
        {
        this.setState({show_options_dialog: false}) ;
        }

    open_save_menu ()
        {
        const sc = V3DSpace.get_all_sc_id ()

        if  (sc.length === 0)
            {
            const status_msg = {
                content:    `Please select one or more spacecraft before trying to save
                            orbit position data`,
                className: 'time_set_error',
                style: {marginTop: '15vh',},
                }
    
            message.error (status_msg) ;  
            
            return ;
            }

        this.setState({show_save_dialog: true}) ;
        }

    copy_search_url ()
        {
        const url = V3DSpace.create_url ()

        const { confirm } = Modal ;

        confirm (
            {
            title: 'Copy URL to Recreate Display to Clipboard',
            content: url,
            width: MIN_DIALOG_WIDTH,
            okText: 'Copy',
            icon: <QuestionCircleOutlined />,
            onOk () {navigator.clipboard.writeText(url) ; return false},
            onCancel () {},
            }) ;

        }

    close_save_menu ()
        {
        this.setState({show_save_dialog: false}) ;
        }

    set_screen_capture_background (compost, clr="white")
        {
        const ctx = compost.getContext('2d')

        ctx.beginPath ()
        ctx.rect (0, 0, compost.width, compost.height)
        ctx.fillStyle = clr
        ctx.fill()
    
        ctx.drawImage (this.capture, 0, 0)
        }

    add_time_date (compost)
        {
        const display_time = epoch_to_date_time (V3DSpace.time, true)

        const ctx = compost.getContext('2d')

        ctx.font = "22px Arial"
        ctx.fillStyle = "white"
        ctx.strokeStyle = 'DarkSlateGrey'
        ctx.lineWidth = 2

        const text = "Time: " + display_time 
        const width = ctx.measureText (text).width

        // Draw the time and date on the image
        ctx.strokeText(text, (compost.width / 2 - width / 2).toFixed (), compost.height - 30);
        // ctx.fillText(text, 10, compost.height - 10);
        // ctx.fillText(text, 10, 10);
        
        }

    get_img_dimensions (dx, dy)
        {
        const ar = V3DSpace.height / V3DSpace.width 

        const bound_x = Math.floor (dx * .8)
        const bound_y = Math.floor (dy / 2)

        const area_1 = bound_x * bound_x * ar
        const area_2 = bound_y * bound_y / ar

        if  (area_1 > area_2)
            {
            return [Math.floor (bound_y / ar), bound_y]
            }

        else
            {
            return [bound_x, Math.floor (bound_x * ar)]
            }
        }


    update_compost_bg_color (color, event)
        {
        const compost = new OffscreenCanvas (V3DSpace.width, V3DSpace.height) 

        this.set_screen_capture_background (compost, color.hex)
        
        this.add_time_date (compost)

        this.setState ({compost: compost})
        }

    open_image_save_menu ()
        {
        // Take the screen shot as soon as the image is requested.
        this.capture.height = V3DSpace.height 
        this.capture.width = V3DSpace.width

        const compost = new OffscreenCanvas (V3DSpace.width, V3DSpace.height)

        const ctx = this.capture.getContext('2d')

        ctx.drawImage (V3DSpace.display, 0, 0)

        /*
        html2canvas (this.ui.current, {backgroundColor: null})
        
            .then (canvas => 
                {
                // Do something with the resulting canvas
                ctx.drawImage (canvas, 0, 0)

                this.set_screen_capture_background (compost)

                this.setState ({show_image_dialog: true, compost: compost})

                }) ;
        */

        this.set_screen_capture_background (compost)

        this.add_time_date (compost)

        this.setState ({show_image_dialog: true, compost: compost})
        }

    close_image_save_menu ()
        {
        this.setState({show_image_dialog: false, }) ;
        }

    open_coord_dialog ()
        {
        this.setState({show_coord_dialog: true}) 
        }

    close_coord_dialog ()
        {
        this.setState({show_coord_dialog: false})
        }

    update_save_target (e)
        {
        this.setState ({save_to_file: e.target.value}) ;
        }

    update_img_save_target (e)
        {
        this.setState ({img_save_to_file: e.target.value}) ;
        }

        update_log_save_target (e)
        {
        this.setState ({log_save_to_file: e.target.value})
        }

    update_save_file_name (e)
        {
        this.setState ({save_file_name: e.target.value}) ;
        }
 
    update_img_save_file_name (e)
        {
        this.setState ({img_save_file_name: e.target.value})
        }

        update_log_save_file_name (e)
        {
        this.setState ({log_save_file_name: e.target.value})
        }

    save_or_display_log ()
        {
        const log = new Blob (window.log_messages, {type: "text/plain;charset=utf-8"})

        if  (this.state.log_save_to_file)
            {
            saveAs (log, this.state.log_save_file_name) 
            }

        else
            {
            window.open (URL.createObjectURL (log), 
                'listing', 
                'width=800, height=600, left=200, top=200') 
            }
        }

    update_selected_for_save (e)
        {
        const newlist = this.state.list.slice () ;
        const index = e.target.index ;
        
        newlist [index] = ! newlist [index] ;

        this.setState ({list: newlist}) ;
        }

    update_coord_system (e)
        {
        V3DSpace.set_coord_system (key_to_coord_system (e.target.name))
        }

    update_reference_frame (e)
        {
        if  (e.target.checked)
            {
            V3DSpace.set_reference_frame (REF_FRAME.ECER)
            }

        else 
            {
            V3DSpace.set_reference_frame (REF_FRAME.ECI)
            }
        }

    save_selected_orbits ()
        {
        const dfrmt = 'YYYY MMM DD HH:mm:ss' ;
        const lfrmt = '%s      %15.3f  %15.3f  %15.3f\n' ;

        let text = [] ;

        const sc = V3DSpace.get_all_sc_id ()

        for (let i = 0 ; i < this.state.list.length ; i++)
            {
            if  (! this.state.list [i])
                {
                continue ;
                }

            const id = sc [i]
            
            const time = V3DSpace.get_orbit_times (id)
            const coord = V3DSpace.get_orbit_coord (id, COORD_System.GSE)

            const n = time.length 
            const tstart = moment.utc(time [0]).format(dfrmt) ;
            const tend   = moment.utc(time [n-1]).format(dfrmt) ;

            //text.push (orbit_data_header (id, tstart, tend, 'Re', coord_system_to_key (V3DSpace.coord_system))) ;
            text.push (orbit_data_header (id, tstart, tend, 'Re', coord_system_to_key (COORD_System.GSE))) ;

            for (let t = 0 ; t < n ; t++)
                {
                const ts = moment.utc(time [t]).format(dfrmt) ;
                //const loc = new THREE.Vector3 ().fromArray (coord, t*3) ;

                text.push (sprintf (lfrmt, 
                            ts, 
                            coord [t].x, 
                            coord [t].y, 
                            coord [t].z)) ;
                }

            text.push (orbit_data_footer ())
            }    

        if  (text.length !== 0)
            {
            const display = new Blob (text, {type: "text/plain;charset=utf-8"}) ;

            if  (this.state.save_to_file)
                {
                saveAs (display, this.state.save_file_name) ;
                }
            else
                {
                window.open (   URL.createObjectURL (display), 
                                'listing', 
                                'width=800, height=600, left=200, top=200') ;

                }
            }

        this.close_save_menu ()
        }

    save_image ()
        {
        const fn = this.state.img_save_file_name ;

        // const re_check_png_extension = /^([^.]*).png$/m 
        const re_check_any_extension = /^([^.]*)$/m
        
        const save_file_name = (re_check_any_extension.test (fn))? fn  + '.png': fn

        this.state.compost.convertToBlob ({type: "image/png"})
        .then (png => {
            if  (this.state.img_save_to_file)
                {
                saveAs (png, save_file_name)
                }
            else 
                {
                window.open (URL.createObjectURL (png), 'screenshot')
                }
            })

        //

        this.close_image_save_menu ()
        }

    toggle_l_sidebar ()
        {
        const visible = this.state.l_sidebar_visible 

        if  (visible)
            {
            this.hide_l_sidebar ()
            }

        else
            {
            this.show_l_sidebar ()
            }
        }

    show_l_sidebar () 
        {
        this.setState ({l_sidebar_visible: true}) ;
        }
        
    hide_l_sidebar ()
        {
        this.setState ({l_sidebar_visible: false}) 
        }
        
    set_xy_grid_options (e)
        {
        const key = e.currentTarget.getAttribute ("name") 
        const val = parseInt (e.currentTarget.value) 

        V3DSpace.update_xy_grid_options (key, val)
        }
    

    set_yz_grid_options (e)
        {
        const key = e.currentTarget.getAttribute ("name") 
        const val = parseInt (e.currentTarget.value) 

        V3DSpace.update_yz_grid_options (key, val)
        }
        
    set_xz_grid_options (e)
        {
        const key = e.currentTarget.getAttribute ("name")
        const val = parseInt (e.currentTarget.value) 

        V3DSpace.update_xz_grid_options (key, val)
        }

    componentDidMount ()
        {
        //alert (this.props.msg) ;
        }

    render () 
        {
        /*
        <Tooltip    placement="Bottom" 
                    color={TT_BGCOLOR}
                    title="Opens a pannel which allows the selection of both the 
                            the time interval over which to display spacecraft orbits
                            as well the specific obsertavories to display orbits for.">

        <Tooltip    placement="Bottom" 
                    color={TT_BGCOLOR}
                    title="Not currently functional.">

        */

        //const display_list = this.props.selected_id.map ((item)=>item.id) ;
        //const time_string = moment.utc(this.props.time).format('YYYY MMM DD HH:mm:ss') ;

        const { Title } = Typography;

        const dx = V3DSpace.width
        const dy = V3DSpace.height

        const [img_width, img_height] = this.get_img_dimensions (scr_dlg_width (dx), DIALOG_HEIGHT)

        return (
            <>
                <Modal
                    title={'Options'}
                    icon={null}
                    centered={true}
                    width={opt_dlg_width (dx)}
                    bodyStyle={get_dlg_style (dx, opt_dlg_width)}
                    open={this.state.show_options_dialog}
                    onCancel={this.close_option_menu}
                    footer={[
                        <Button type="primary" onClick={this.close_option_menu}>
                            Done
                        </Button>,
                        ]}
                    modalRender={(modal) => (
                        <Draggable bounds={get_bounds_box (dx, dy, opt_dlg_width)} >
                            <div ref={this.draggleRef}>{modal}</div>
                        </Draggable>
                        )}
                    >
                    <Options
                        update_axes_length={this.update_axes_length}
                        toggle_axes_display={this.toggle_axes_display}
                        axes_length={this.state.axes_length}
                        bgcolor={this.state.bgcolor}
                        update_bg_color={this.update_bg_color}
                        hide_time_control={this.state.hide_time_control}
                        show_decals={this.state.show_decals}
                        show_planet_decals={this.state.show_planet_decals}
                        toggle_show_decals={this.toggle_show_decals}
                        toggle_show_planet_decals={this.toggle_show_planet_decals}
                        show_sc_position={this.state.show_sc_position}
                        toggle_show_sc_position={this.toggle_show_sc_position}
                        toggle_hide_time_control={this.toggle_hide_time_control}
                        set_xz_grid_options={this.set_xz_grid_options}
                        set_yz_grid_options={this.set_yz_grid_options}
                        set_xy_grid_options={this.set_xy_grid_options}
                        update_save_target={this.update_log_save_target}
                        save={this.state.log_save_to_file}
                        save_file_name={this.state.log_save_file_name}
                        update_save_file_name={this.update_log_save_file_name}
                        log_action={this.save_or_display_log}
 
                        />
                </Modal>
                <Modal
                    title={'Export Orbit Data as Text'}
                    icon={null}
                    centered={true}
                    width={xp_dlg_width (dx)}
                    bodyStyle={get_dlg_style (dx, xp_dlg_width)}
                    open={this.state.show_save_dialog}
                    onCancel={this.close_save_menu}
                    onOk={this.save_selected_orbits}
                    >
                    <Listing_Select
                        selected_id={this.props.selected_id} 
                        list={this.state.list}
                        update={this.update_selected_for_save}
                        update_save_target={this.update_save_target}
                        save={this.state.save_to_file}
                        save_file_name={this.state.save_file_name}
                        update_save_file_name={this.update_save_file_name}
                        />
                </Modal>
                <Modal
                    title={'Select A Coordinate System'}
                    icon={null}
                    centered={true}
                    width={opt_dlg_width (dx)}
                    bodyStyle={get_dlg_style (dx, opt_dlg_width)}
                    open={this.state.show_coord_dialog}
                    onCancel={this.close_coord_dialog}
                    footer={[
                        <Button type="primary" onClick={this.close_coord_dialog}>
                            Done
                        </Button>,
                        ]}
                    modalRender={(modal) => (
                        <Draggable bounds={get_bounds_box (dx, dy, opt_dlg_width)}>
                            <div ref={this.draggleRef}>{modal}</div>
                        </Draggable>
                        )}
                    >
                    <Coordinate_System_Select
                        update={this.update_coord_system}
                        system={V3DSpace.coord_system}
                        current_ref_frame={V3DSpace.reference_frame === REF_FRAME.ECER}
                        update_ref_frame={this.update_reference_frame}
                        />
                </Modal>

                <Modal
                    title={'Save Screen Shot'}
                    icon={null}
                    centered={true}
                    width={scr_dlg_width (dx)}
                    open={this.state.show_image_dialog}
                    bodyStyle={get_dlg_style (dx, scr_dlg_width)}
                    onCancel={this.close_image_save_menu}
                    onOk={this.save_image}
                    >
                    <IMG_Save_Modal 
                        img_width={img_width}
                        img_height={img_height}
                        use_narrow_format={use_min_width (dx)}
                        compost={this.state.compost}
                        update_bg_color={this.update_compost_bg_color}
                        update={this.update_selected_for_save}
                        update_save_target={this.update_img_save_target}
                        save={this.state.img_save_to_file}
                        save_file_name={this.state.img_save_file_name}
                        update_save_file_name={this.update_img_save_file_name}
                        />
                </Modal>

                <Display_Manager
                        start_time={this.props.start_time}
                        end_time={this.props.end_time}
                        set_frame={this.props.set_frame}
                        set_focus={this.props.set_focus}
                        target={this.props.target}
                        update_master_time={this.props.update_master_time}
                        transport_bar_help={this.display_transport_bar_help_dialog}
                        time={this.props.time}
                        axes_length={this.state.axes_length}
                        hide_time_control={this.state.hide_time_control}
                        show_sc_position={this.state.show_sc_position}
                        msg={this.props.msg}
                        ui={this.ui}
                        display_main_help_dialog={this.display_main_help_dialog}
                        toggle_l_sidebar={this.toggle_l_sidebar}
                        open_save_menu={this.open_save_menu}
                        copy_search_url={this.copy_search_url}
                        open_image_save_menu={this.open_image_save_menu}
                        open_option_menu={this.open_option_menu}
                        open_coord_dialog={this.open_coord_dialog}
                        />
                <div className = "drawer_box">
                    <Drawer
                        placement="left"
                        closable={true}
                        width="500"
                        keyboard={false}
                        forceRender={true}
                        closeIcon={<CloseSquareFilled style={{color: "grey"}} />}
                        onClose={this.hide_l_sidebar}
                        open={this.state.l_sidebar_visible}
                        getContainer={false}
                        style={{position: "absolute", }}
                        bodyStyle={{padding: "1vh",
                                    margin: 0, 
                                    border: 0, 
                                    backgroundColor: "#787878"}}
                        >
                    
                        <Control_Layout 
                            start_time={this.props.start_time}
                            end_time={this.props.end_time}
                            sats={this.props.sats}
                            update_view_start_time={this.props.update_view_start_time}
                            update_view_end_time={this.props.update_view_end_time}
                            get_new_color={this.props.get_new_color}
                            get_new_shape={this.props.get_new_shape}
                            display_help={this.display_chooser_help_dialog}
                            set_focus={this.props.set_focus}
                            hide_l_sidebar={this.hide_l_sidebar}
                            request={this.props.request}
                            />

                    </Drawer>
                </div>

            </>
            )
    
        }
    }

// This probably needs to go somewhere else.
class Manager extends React.Component
    {
    constructor (props)
        {
        super (props)

        // Example:
        // http://localhost:3000/test3017/4dorbit?spacecraft=ace;wind&start=20211011T121314&stop=20211012T121314

        const default_interval  = this.props.interval ? this.props.interval : 1 ;

        const query = window.location.search
        const params = new URLSearchParams (query)

        const start = date_param_to_epoch (params.get ('start'))
        const stop = date_param_to_epoch (params.get ('stop'))
        const sc = params.get ('sc')
        const spacecraft= params.get ('spacecraft')

        const t0 = (start && stop && start < stop) ? start : default_start_time (default_interval)
        const t1 = (start && stop && start < stop) ? stop : default_end_time ()
            
        this.default_request = []

        if  (sc)
            {
            this.default_request.push (...sc.split (";"))
            }

        if  (spacecraft)
            {
            this.default_request.push (...spacecraft.split (";"))
            }

        this.state =  {
            sats: null,
            GS: null,
            planets: PLANETS,
            selected: [],
            start_time: t0,
            end_time: t1,
            time: t0,
            text: "",
            display_properties: null,
            target: V3DSpace.target_label,
            //request: [],
            //orbits: null,
            init: false,
            }

        this.get_obs_list = this.get_obs_list.bind (this)
        this.get_ground_stations = this.get_ground_stations.bind (this)
        //this.get_orbit_data = this.get_orbit_data.bind (this) ;
        //this.update_selection = this.update_selection.bind (this)
        this.update_view_start_time = this.update_view_start_time.bind (this)
        this.update_view_end_time   = this.update_view_end_time.bind (this)
        //this.add_orbit = this.add_orbit.bind (this)
        //this.remove_orbit = this.remove_orbit.bind (this)
        this.get_new_color = this.get_new_color.bind (this)
        this.get_new_shape = this.get_new_shape.bind (this)
        this.handle_OK = this.handle_OK.bind (this)
        this.handle_color_response = this.handle_color_response.bind (this)
        this.set_focus = this.set_focus.bind (this)
        this.set_frame = this.set_frame.bind (this)
        this.handle_keypress = this.handle_keypress.bind (this)
        this.update_master_time = this.update_master_time.bind (this)
        this.set_properties = this.set_properties.bind (this) 
        this.render = this.render.bind (this)

        this.message = React.createRef() 

        V3DSpace.set_start_time (this.state.start_time)
        V3DSpace.set_end_time (this.state.end_time)
        V3DSpace.add_all_planets ()
        V3DSpace.update_orbit_data ()
        }

    update_view_start_time (time)
        {
        const new_start_time = time.valueOf() ;
        const end_time = this.state.end_time ;
        const sats = this.state.sats ;

        if  (new_start_time < end_time)
            {   
            for (let i = 0 ; i < sats.length - 1 ; i++)
                {
                sats [i].available = (end_time < sats[i].start_time || new_start_time > sats[i].end_time )? false : true ;
                /*
                if  (end_time < sats[i].start_time || new_start_time > sats[i].end_time )
                    {
                    // Orbit data not available for current time range.
                    sats [i].available = false ;
                    }
                else
                    {
                    // Orbit data available!
                    sats [i].available = true ;
                    }
                */
                }

            V3DSpace.set_start_time (new_start_time)

            this.setState ({start_time: new_start_time,
                            }) ;
            }

        else
            {
            const status_msg = {
                content: 'Start Time Must Be Earlier Than End Time.',
                className: 'time_set_error',
                style: {marginTop: '15vh',},
                }

            message.error (status_msg) ;
            }
        }

    update_view_end_time (time)
        {
        const new_end_time = time.valueOf() ;
        const start_time = this.state.start_time ;
        const sats = this.state.sats ;
    
        if  (new_end_time > start_time)
            {
            for (let i = 0 ; i < sats.length - 1 ; i++)
                {
                sats [i].available = (new_end_time < sats[i].start_time || start_time > sats[i].end_time )? false : true ;
                /*
                if  (new_end_time < sats[i].start_time || start_time > sats[i].end_time )
                    {
                    // Orbit data not available for current time range.
                    sats [i].available = false ;
                    }
                else
                    {
                    // Orbit data available!
                    sats [i].available = true ;
                    }
                */
                }
    
            V3DSpace.set_end_time (new_end_time)

            this.setState ({end_time: new_end_time,
                }) ;
            }

        else
            {
            const status_msg = {
                content: 'End Time Must Be Later Than Start Time.',
                className: 'time_set_error',
                style: {marginTop: '15vh',},
                }
    
            message.error (status_msg) ;
            }
        }

    // update_selection (selection)
    /*
    update_selection (record, add_flag)
        {
        alert ('updating selection')
        if  (add_flag)
            {
            this.add_orbit (record) ;
            }

        else
            {
            this.remove_orbit (record) ;
            }
        }
    */

    /*
    add_orbit (record)
        {
        const current_selection = this.state.selected ;
        const start_time = this.state.start_time ;
        const end_time = this.state.end_time ;

        if  (end_time < record.start_time || start_time > record.end_time )
            {
            const status_msg = {
                content: 'Orbit data not available for selected time range.',
                className: 'time_set_error',
                style: {marginTop: '15vh',},
                }

            message.error (status_msg) ;    
            }

        else 
            {
            const new_selection = [...current_selection, record.key] ;

            const index = this.state.sats.findIndex ((item) => record.key === item.key) ;
            const item = this.state.sats [index] ;

            console.log (JSON.stringify (item))

            V3DSpace.add_spacecraft ({
                id: item.id, 
                color: item.color, 
                shape: item.shape, 
                focus: null,
                name: item.name, 
                type: ENT_type.SPACECRAFT, 
                start_time: item.start_time, 
                end_time: item.end_time,
                orbit_class: item.orbit, 
                cadence: item.cadence
                })

            //const request = (({ id, color, shape }) => ({ id, color, shape }))(blah [index]);

            // Mark the display status of the record.
            record.display = true ;

            this.setState ({    
                selected: new_selection,
                }) ;

            }

        }

    remove_orbit (record)
        {
        const current_selection = this.state.selected ;
       //const current_request = this.state.selected_id ;

        const i = current_selection.indexOf (record.key) ;
        //const has_focus = assets.get (record.id).focus ;

        
        
        const selection = 
            (current_selection.length > 0) ?
                [...current_selection.slice(0,i),...current_selection.slice(i+1)] :
                [] ;

        // Mark the display status of the record.
        record.display = false ;

        V3DSpace.remove (record.id)

        // If we have focus, then we will also have to clear that when we update the
        // the display list.

        this.setState ({
            selected: selection,
            request: null,
            })
        }
    */

    set_properties (p)
        {
        this.setState ({display_properties: p})
        }

    get_obs_list (obs) 
        {
        this.setState ({sats: obs}) ;
        }

    get_ground_stations (ground_stations) 
        {
        V3DSpace.set_GS_location (ground_stations)

        this.setState ({GS: ground_stations}) ;
        }

    set_focus (id)
        {
        this.setState ({target: V3DSpace.set_focus (id)})
        }
        
    set_frame (frame="EARTH")
        {
        this.setState ({target: V3DSpace.update_frame (frame)}) ;
        }

    handle_OK ()
        {

        // Note:  We are actually creating a shallow copy of this.state.sats here, so all of the
        // array elements (objects) will be copied by reference.  Doing this so we can force
        // an update.
        const new_sats = [...this.state.sats] ;
        const index = new_sats.findIndex ((item) => this.orbit_recolor_key === item.key) ;
        const item = new_sats [index] ;

        item.color = this.new_color.hex ;

        V3DSpace.set_color (item.id, item.color) 

        this.setState({sats: new_sats, }) ;

        this.color_select.destroy () ;
        }

    get_new_color (color, record) 
        {

        const { confirm } = Modal ;

        this.modal_width = 400 ;
        this.orbit_recolor_key = record.key ;

        this.color_select = confirm (
            {
            title: 'Select Orbit Color',
            okButtonProps: {onClick: this.handle_OK},
            content: <SketchPicker   
                        onChangeComplete={ this.handle_color_response } 
                        color={color}
                        width={this.modal_width * .85} 
                        disableAlpha={ true }
                        />,
            icon: null,
            onOk () {},
            onCancel () {},
            }) ;
        } 

    get_new_shape (shape, record)
        {
        // Note:  We are actually creating a shallow copy of this.state.sats here, so all of the
        // array elements (objects) will be copied by reference.  Doing this so we can force
        // an update.
        const new_sats = [...this.state.sats] ;
        const index = new_sats.findIndex ((item) => record.key === item.key) ;
        const item = new_sats [index] ;

        item.shape = shape ;

        V3DSpace.set_shape (item.id, item.shape)

        this.setState({sats: new_sats,}) ;
        }

    handle_keypress (e)
        {
        const ESCAPE_KEY = 27 ;
        
        switch ( e.keyCode ) 
            {
            case ESCAPE_KEY:
                this.setState ({target: V3DSpace.clear_focus ()})
                break;

            default: 
                break;
            }        
        }

    handle_color_response (color, event)
        {
        this.new_color = color ;

        this.color_select.update (
            {content: <SketchPicker   onChangeComplete={ this.handle_color_response } 
            color={color.hex}
            width={this.modal_width * .85} 
            disableAlpha={ true }
            />,});
        }

    update_master_time (new_time)
        {
        this.setState ({time: new_time}) ;
        }

    componentDidMount ()
        {
        document.addEventListener("keydown", this.handle_keypress)

        V3DSpace.register_msg_portal (this.message.current)
        }

    componentWillUnmount ()
        {
        document.removeEventListener("keydown", this.handle_keypress) ;
        }


    render ()
        {
        return (
              <>
                    {this.state.display_properties
                        
                        ? <Get_Observatories 
                            obs={this.get_obs_list}
                            start_time={this.state.start_time}
                            end_time={this.state.end_time}
                            display_properties={this.state.display_properties}
                            />

                        : <Read_Properties_File 
                            set_properties={this.set_properties}
                            />

                    }

                    <Message_Queue  ref={this.message} />

                    <Get_Ground_Stations ground_stations={this.get_ground_stations} />

                    {this.state.sats

                        ? <Base_Layout
                            start_time={this.state.start_time}
                            end_time={this.state.end_time}
                            sats={this.state.sats}
                            update_view_start_time={this.update_view_start_time}
                            update_view_end_time={this.update_view_end_time}
                            get_new_color={this.get_new_color}
                            get_new_shape={this.get_new_shape}
                            set_focus={this.set_focus}
                            set_frame={this.set_frame}
                            target={this.state.target}
                            time={this.state.time}
                            update_master_time={this.update_master_time}
                            msg={this.message}
                            request={this.default_request}
                            />

                        : null
                    }
             </>
              
            ) ;
        }
    }


// export default Get_Observatories;
export default Manager ;

